export enum PaymentServiceRoutes {
    Flight_Search = 'flight-search',
    Updated_Flight_Offer = 'updated-offer',
    Create_Order = 'create-order',
};
